/* eslint-disable id-length */
import {createTheme} from '@mui/material/';

// Custom MUI theme for the notebook ai pipeline with chat
export const appTheme = createTheme({
  spacing: 4, // Base spacing unit,
  shape: {
    borderRadius: 4,
  },
  typography: {
    fontFamily: 'Roboto Flex, Roboto, Arial, sans-serif',
    fontWeightRegular: 400,
    fontWeightMedium: 450,
    fontWeightBold: 500,
    h3: {
      fontSize: '28px',
    },
    h5: { // Review this after merging with base theme in this case, it should be not necessary
      fontSize: '22px',
      lineHeight: '28px'
    },
    body1: {
      fontSize: '16px',
      lineHeight: '24px'
    },
    button: {
      textTransform: 'initial',
    },
    body2: {
      fontSize: 14,
      lineHeight: '18px'
    }
  },
//   custom: {
//     buttonBorderColor: '#787879 !important',
//     darkerBorder: '#383839 !important',
//     darkerText: '#B4B4B5 !important',
//     darkerInput: '#1D1D1D !important',
//     getBorderRadius: (factor: number) => factor * 4,
//   },
  palette: {
    mode: 'dark',
    primary: {
      main: '#4b88ad',
      light: '#daeaf7'
    },
    background: {
      default: '#161617',
      paper: '#252526',
    },
    grey: {
      500: '#b4b4b5',
      600: '#787879',
      800: '#424242',
      900: '#2D2D2D'
    },
    text: {
      primary: '#787879',
      secondary: '#b4b4b5'
    },
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: ({theme}) => ({
          color: theme.palette.text.secondary
        }),
      }
    },
    MuiTableContainer: {
      styleOverrides: {
        root: ({theme}) => ({
          border: `1px solid #383839 !important`,
          borderRadius: theme.shape.borderRadius
        }),
      },
    },
    MuiTable: {
      styleOverrides: {
        root: () => ({
          borderCollapse: 'collapse',
          borderStyle: 'hidden'
        }),
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: ({theme}) => ({
          color: theme.palette.text.primary,
          padding: `${theme.spacing(3)} ${theme.spacing(2)}`
        }),
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: () => ({
          backgroundColor: appTheme.palette.background.paper,
          borderRadius: '3px',
          padding: 0,
          '&.Mui-checked': {
            backgroundColor: 'white',
          },
          '&.MuiCheckbox-indeterminate': {
            backgroundColor: 'white',
          },
          '& svg': {
            scale: '1.4',
          }
        }),
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: () => ({
          fontSize: 18
        }),
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: ({theme}) => ({
          '& .MuiButton-root': {
            color: theme.palette.grey[500]
          },
        }),
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: () => ({
          color: '#fff'
        }),
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: ({theme}) => ({
          color: `${theme.palette.grey[500]}!important`
        }),
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: ({theme}) => ({
          backgroundColor: theme.palette.grey[900],
          color: theme.palette.text.secondary,
          borderRadius: 2,
        })
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: ({theme}) => ({
          margin: 0,
          background: theme.palette.background.default,
          fontSize: 11,
          '&.Mui-error': {
            color: '#d64541',
            fontSize: '0.75rem !important'
          },
        })
      }
    },
    MuiToggleButton: {
      styleOverrides: {
        root: ({theme}) => ({
          border: 'none',
          backgroundColor: '#1E1E1E',
          color: theme.palette.text.primary,
          '&.Mui-selected': {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.secondary,
          },
        }),
      },
    },
    MuiList: {
      styleOverrides: {
        root: ({theme}) => ({
          color: theme.palette.text.secondary
        }),
      },
    },
    MuiLink: {
      styleOverrides: {
        root: ({theme}) => ({
          textDecoration: 'none',
          color: theme.palette.primary.light,
          fontWeight: 500,
          fontSize: 14
        }),
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundImage: 'none',
          backgroundColor: '#272728',
          minWidth: 200,
          borderRadius: '8px',
          border: '1px solid #383839',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d64541',
          }
        },
      },
    }
  }
});

export const actionBarStyles = {
  extractor: {
    backgroundColor: '#461E39',
    height: 'auto'
  },
  transformation: {
    backgroundColor: '#243949',
    height: '56px'
  },
  visualization: {
    backgroundColor: '#341E46',
    height: '56px'
  },
  markdown: {
    backgroundColor: '#3D331A',
    height: '56px'
  },
  code: {
    backgroundColor: '#2E2E2F',
    height: '56px'
  },
  load: {
    backgroundColor: '#1C244C',
    height: '56px'
  }
};


export const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '450px',
  backgroundColor: appTheme.palette.background.paper,
  border: `1px solid #383839 !important`,
  padding: appTheme.spacing(8),
  borderRadius: 4
};

export const textFieldStyle = {
  width: '100%',
  marginBottom: appTheme.spacing(8),
  '& .MuiOutlinedInput-root': {
    color: '#FFFFFF',
    height: '40px',
    padding: `0 ${appTheme.spacing(3)}px`,
    '& input': {
      padding: `${appTheme.spacing(3)}px 0`,
    },
    '& fieldset': {
      borderColor: '#383839 !important',
    }
  },
  '& .MuiInputLabel-root': {
    color: appTheme.palette.grey[500],
    fontSize: '14px',
  },
};

export const readOnlyTextFieldStyle = {
  backgroundColor: '#2E2E2F80',
  borderRadius: `4px`,
  '& .MuiOutlinedInput-root': {
    color: `${appTheme.palette.text.primary}`,
    '& fieldset': {
      border: 'none',
      borderRadius: `4px`,
    },
  },
};

export const primaryButtonStyle = {
  background: appTheme.palette.primary.main,
  color: '#FFFFFF',
  '&:hover': {
    backgroundColor: appTheme.palette.primary.main,
  },
  fontWeight: 500
};